import type { AlertContentBlock, AlertMessage, AlertSpacerSize, AlertTextSegment } from './alertMessageTypes';

import './_styles.scss';

interface AlertMessageContentClassNames {
    paragraph?: string;
    root?: string;
    spacer?: string;
    spacerSize?: (size: AlertSpacerSize) => string;
    title?: string;
}

interface AlertMessageContentProps {
    classNames?: AlertMessageContentClassNames;
    message: AlertMessage;
}

const getClassName = (...classNames: Array<string | undefined>) => classNames.filter(Boolean).join(' ');

const TextSegment = ({ segment }: { segment: AlertTextSegment }) =>
    segment.bold ? <strong>{segment.text}</strong> : <>{segment.text}</>;

const ContentBlock = ({
    block,
    classNames,
    index,
}: {
    block: AlertContentBlock;
    classNames?: AlertMessageContentClassNames;
    index: number;
}) => {
    if (block.type === 'spacer') {
        const size = block.size ?? 'medium';

        return (
            <div
                aria-hidden='true'
                className={getClassName(
                    'AlertMessageContent__spacer',
                    `AlertMessageContent__spacer--${size}`,
                    classNames?.spacer,
                    classNames?.spacerSize?.(size)
                )}
            />
        );
    }

    return (
        <p className={getClassName('AlertMessageContent__paragraph', classNames?.paragraph)}>
            {block.segments.map((segment, segmentIndex) => (
                <TextSegment key={`${index}-${segmentIndex}`} segment={segment} />
            ))}
        </p>
    );
};

const AlertMessageContent = ({ classNames, message }: AlertMessageContentProps) => (
    <div className={getClassName('AlertMessageContent', classNames?.root)}>
        <strong className={getClassName('AlertMessageContent__title', classNames?.title)}>{message.title}</strong>
        {message.content?.map((block, index) => (
            <ContentBlock key={index} block={block} classNames={classNames} index={index} />
        ))}
    </div>
);

export default AlertMessageContent;
